import React, { useEffect, useState } from "react";
import { TableComponents } from "../strainght/TableComponents.tsx";
import { ParlayGameTeam } from "./ParlayGameTeam.tsx";
import { Schedule } from "../../../../models/Schedule.tsx";
import { useBetContext } from "../../../../context/ParlayBetContext.tsx";
import { useUser } from "../../../../context/UserContext.tsx";
import { Odd } from "../../../../models/Odd_response_model.tsx";

import { getDrawOddsGroup } from "../../../../helpers/functions.tsx";
import { handleScheduleColumnToggle } from '../../../../helpers/scheduleColumnToggle.ts';
import { Link } from "react-router-dom";

interface IParlaygameComponents {
    game: Schedule,
    setShowLimitAlert: React.Dispatch<React.SetStateAction<boolean>>,
    showHeaderByLeague: boolean;
    showHeaderByDate: boolean;
    setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
}

export function ParlayGames(props: IParlaygameComponents) {
    const { game, showHeaderByLeague, showHeaderByDate, setShowLimitAlert, setErrorMessage } = props;
    const { user } = useUser();
    if (!user?.userName) {
        throw new Error("User not authenticated");
    }

    const gameTimeDate = new Date(game.start_date ?? '')

    const time = gameTimeDate.toLocaleTimeString('en-US', {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: "short"
    });

    const isGolf = game.sport?.id === 'golf';

    // console.log("lo mio",gameTimeDate, )
    // console.log("lo de la API",game.start_date, Date.parse(game.start_date) )
    const formattedDate = new Date(game.start_date).toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
    }).toUpperCase();
    const { setBets } = useBetContext();
    const [organizedOdds, setOrganizedOdds] = React.useState<Odd[][]>([]);
    const [theRestOfOdds, setTheRestOfOdds] = React.useState<Odd[][]>([]);
    const [pitchersChecked, setPitchersChecked] = useState<Record<string, { away: boolean; home: boolean }>>({});

    const handlePitcherChange = (gameId: string, team: "away" | "home") => {
        setPitchersChecked(prev => ({
            ...prev,
            [gameId]: {
                away: prev[gameId]?.away ?? false,
                home: prev[gameId]?.home ?? false,
                [team]: !(prev[gameId]?.[team] ?? false)
            }
        }));
    };

    useEffect(() => {
        setBets((prevBets: any) => {
            let changed = false;
            const next = prevBets.map((bet: any) => {
                if (bet.league !== "MLB" || !bet.gameId) return bet;

                const checked = pitchersChecked[bet.gameId];
                if (!checked) return bet;

                const away = checked.away ?? false;
                const home = checked.home ?? false;

                if (
                    bet.pitchers?.away === away &&
                    bet.pitchers?.home === home &&
                    bet.pitchers?.names
                ) {
                    return bet;
                }

                changed = true;
                return {
                    ...bet,
                    pitchers: {
                        away,
                        home,
                        names: {
                            away: bet.pitchers?.names?.away ?? "",
                            home: bet.pitchers?.names?.home ?? "",
                        },
                        ids: {
                            away: bet.pitchers?.ids?.away ?? "",
                            home: bet.pitchers?.ids?.home ?? "",
                        },
                    },
                };
            });
            return changed ? next : prevBets;
        });
    }, [pitchersChecked, setBets]);

    const handleColumnToggle = handleScheduleColumnToggle;

    useEffect(() => {

        const groupOddsByMarket = (Object.groupBy(game.odds ?? [], odd => odd.market_id) as { [key: string]: Odd[] }) ?? {};

        const marketsId = Object.keys(groupOddsByMarket);

        const tmpHomeOdds = marketsId.map(marketId => {
            const oddsHome = groupOddsByMarket[marketId].filter(
                o => o.selection === game.home_team_display || (o.selection_line === 'under' && o.selection === "")
            );
            return [...oddsHome];
        }).flat();

        const tmpAwayOdds = marketsId.map(marketId => {
            const oddsAway = groupOddsByMarket[marketId].filter(
                o => o.selection === game.away_team_display || (o.selection_line === 'over' && o.selection === "")
            );
            return [...oddsAway];
        }).flat();


        setTheRestOfOdds(getDrawOddsGroup(game.odds));

        const groupedOdds: Odd[][] = [tmpHomeOdds, tmpAwayOdds];

        setOrganizedOdds(groupedOdds);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>


            {showHeaderByLeague && (<TableComponents game={game} onToggleColumns={handleColumnToggle} />)}
            <div className='gamesGroup'>
                {showHeaderByDate && (
                    <div className='d-flex'>
                        <div className="header-table">
                            <div className="container-date team-name-container">
                                <span className="group ps-1">{formattedDate}</span>
                            </div>
                            <div className="spread-container center-items">
                                {/* <span className='group'>${user?.wagerLimit}</span> */}
                            </div>
                            <div className="moneyline-container center-items d-none d-lg-block">
                                {/* <span className='group'>${user?.wagerLimit}</span> */}
                            </div>
                            <div className="total-container center-items">
                                {/* <span className='group'>${user?.wagerLimit}</span> */}
                            </div>
                            <div className="over-under-container center-items d-none d-lg-block">
                                {/* <span className='group'>${user?.wagerLimit}</span> */}
                            </div>
                        </div>
                    </div>
                )}

                <div className='d-flex'>
                    <span className="group-text teko">{time}</span>
                    {!isGolf && (
                        <div className="live">
                            <Link className={`props-game teko no-link`}
                                to={
                                    `/home/props?` +
                                    `id=${encodeURIComponent(game.id)}` +
                                    `&league=${encodeURIComponent((game.league.id))}` +
                                    `&sport=${encodeURIComponent(game.sport.id)}` +
                                    `&home=${encodeURIComponent(game.home_competitors[0]?.name)}` +
                                    `&away=${encodeURIComponent(game.away_competitors[0]?.name)}` +
                                    `&homeLogo=${encodeURIComponent(game.home_competitors[0]?.logo)}` +
                                    `&awayLogo=${encodeURIComponent(game.away_competitors[0]?.logo)}` +
                                    `&gameId=${encodeURIComponent(game.game_id)}` +
                                    `&GameDate=${encodeURIComponent(game.start_date)}` +
                                    `&logoLeague=${encodeURIComponent(game.leagueLogo)}`
                                }
                                onClick={(e) => {
                                    if (user.status !== "Active") {
                                        e.preventDefault();
                                        setErrorMessage("Your account is in read-only mode."
                                        );
                                        return;
                                    }
                                }}>
                                MORE BETS +
                            </Link>
                        </div>
                    )}
                </div>

                <div>
                    <ParlayGameTeam
                        gameId={game.game_id!}
                        fixture_id={game.id}
                        sport={game.sport.name}
                        gameTime={gameTimeDate}
                        team={game.away_team_display!}
                        league={game.league.name}
                        odds={organizedOdds[1] ?? []}
                        setShowLimitAlert={setShowLimitAlert}
                        gameLogo={game.away_competitors[0]?.logo}
                        opposingTeam={game.home_team_display}
                        pitcherHome={game.home_starter}
                        pitcherAway={game.away_starter}
                        pitcherHomeId={game.home_starter_id}
                        pitcherAwayId={game.away_starter_id}
                        showFlag={true}
                        logoLeague={game.leagueLogo}
                        setErrorMessage={setErrorMessage}
                        user={user}
                        pitchersChecked={pitchersChecked[game.game_id] ?? { away: false, home: false }}
                    />

                    <ParlayGameTeam
                        gameId={game.game_id!}
                        fixture_id={game.id}
                        sport={game.sport.name}
                        gameTime={gameTimeDate}
                        team={game.home_team_display!}
                        league={game.league.name}
                        odds={organizedOdds[0] ?? []}
                        setShowLimitAlert={setShowLimitAlert}
                        gameLogo={game.home_competitors[0]?.logo}
                        opposingTeam={game.away_team_display}
                        pitcherHome={game.home_starter}
                        pitcherAway={game.away_starter}
                        pitcherHomeId={game.home_starter_id}
                        pitcherAwayId={game.away_starter_id}
                        showFlag={false}
                        logoLeague={game.leagueLogo}
                        setErrorMessage={setErrorMessage}
                        user={user}
                        pitchersChecked={pitchersChecked[game.game_id] ?? { away: false, home: false }}
                    />

                    {theRestOfOdds.length > 0 &&
                        theRestOfOdds.map((oddsGroup, index) => (
                            <ParlayGameTeam
                                key={`rest-${index}`}
                                gameId={game.game_id!}
                                fixture_id={game.id}
                                sport={game.sport.name}
                                gameTime={gameTimeDate}
                                team="Draw"
                                league={game.league.name}
                                odds={oddsGroup}
                                setShowLimitAlert={setShowLimitAlert}
                                gameLogo={""}
                                opposingTeam={game.home_team_display}
                                pitcherHome={game.home_starter}
                                pitcherAway={game.away_starter}
                                pitcherHomeId={game.home_starter_id}
                                pitcherAwayId={game.away_starter_id}
                                showFlag={true}
                                logoLeague={game.leagueLogo}
                                setErrorMessage={setErrorMessage}
                                user={user}
                                pitchersChecked={pitchersChecked[game.game_id] ?? { away: false, home: false }}
                            />
                        ))}
                </div>



                {game.league.name === "MLB" && (
                    <div className="pitchers-row">
                        <label className="pitcher-checkbox">
                            <span className="pitcher-name">{game.away_starter || "TBD"} - R</span>
                            <input type="checkbox" className="checkbox-pitcher"
                                checked={!!pitchersChecked[game.game_id]?.away}
                                onChange={() => handlePitcherChange(game.game_id, "away")}
                            />
                        </label>

                        <label className="pitcher-checkbox right">
                            <input type="checkbox" className="checkbox-pitcher"
                                checked={!!pitchersChecked[game.game_id]?.home}
                                onChange={() => handlePitcherChange(game.game_id, "home")}
                            />
                            <span className="pitcher-name">{game.home_starter || "TBD"} - R</span>
                        </label>
                    </div>
                )}
            </div>
        </>
    )
}